import {APP_CONFIG} from  '../environments/environment';
export const api = {
    production: APP_CONFIG.production,
    URL:APP_CONFIG.environment
};